import { toDisplayString as _toDisplayString, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1a74f264")

_pushScopeId("data-v-1a74f264")
const _hoisted_1 = { class: "row mb-3" }
const _hoisted_2 = { class: "col-md-12 fv-row" }
const _hoisted_3 = { class: "required fs-6 fw-bold form-label mb-3" }
const _hoisted_4 = {
  class: "btn-group group-custom",
  role: "group",
  "aria-label": ""
}
const _hoisted_5 = /*#__PURE__*/_createVNode("option", null, null, -1)
const _hoisted_6 = { class: "fv-plugins-message-container" }
const _hoisted_7 = { class: "fv-help-block" }
const _hoisted_8 = { class: "row mb-3" }
const _hoisted_9 = { class: "col-md-12 fv-row" }
const _hoisted_10 = { class: "d-flex align-items-center fs-6 fw-bold form-label mb-1" }
const _hoisted_11 = { class: "required" }
const _hoisted_12 = /*#__PURE__*/_createVNode("i", {
  class: "fas fa-exclamation-circle ms-2 fs-7",
  "data-bs-toggle": "tooltip",
  title: "Specify a objective's title"
}, null, -1)
const _hoisted_13 = { class: "fv-plugins-message-container" }
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = { class: "row mb-3" }
const _hoisted_16 = { class: "col-md-12 fv-row" }
const _hoisted_17 = { class: "d-flex align-items-center fs-6 fw-bold form-label mb-1" }
const _hoisted_18 = /*#__PURE__*/_createVNode("i", {
  class: "fas fa-exclamation-circle ms-2 fs-7",
  "data-bs-toggle": "tooltip",
  title: "Specify a objective's title"
}, null, -1)
const _hoisted_19 = { class: "row mb-3" }
const _hoisted_20 = { class: "col-12" }
const _hoisted_21 = { class: "required fs-6 fw-bold form-label mb-1" }
const _hoisted_22 = { class: "fv-plugins-message-container" }
const _hoisted_23 = { class: "fv-help-block" }
const _hoisted_24 = { class: "row mb-3" }
const _hoisted_25 = { class: "col-md-8 fv-row" }
const _hoisted_26 = { class: "dropdown" }
const _hoisted_27 = {
  class: "btn btn-secondary dropdown-toggle d-none",
  type: "button",
  id: "dropdownMenuButton1",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_28 = {
  class: "dropdown-menu",
  "aria-labelledby": "dropdownMenuButton1"
}
const _hoisted_29 = { class: "fv-plugins-message-container" }
const _hoisted_30 = { class: "fv-help-block" }
const _hoisted_31 = { class: "col-md-4 fv-row" }
const _hoisted_32 = { class: "d-flex align-items-center fs-6 fw-bold form-label mb-1" }
const _hoisted_33 = { class: "fv-plugins-message-container" }
const _hoisted_34 = { class: "fv-help-block" }
const _hoisted_35 = { class: "row mb-3" }
const _hoisted_36 = { class: "fv-plugins-message-container" }
const _hoisted_37 = { class: "fv-help-block" }
const _hoisted_38 = { class: "col-4" }
const _hoisted_39 = { class: "fs-6 fw-bold form-label mb-1" }
const _hoisted_40 = { class: "fv-plugins-message-container" }
const _hoisted_41 = { class: "fv-help-block" }
const _hoisted_42 = { class: "fv-plugins-message-container" }
const _hoisted_43 = { class: "fv-help-block" }
const _hoisted_44 = {
  key: 0,
  class: "row mb-3"
}
const _hoisted_45 = { class: "col-md-6 fv-row" }
const _hoisted_46 = { class: "required fs-6 fw-bold form-label" }
const _hoisted_47 = { class: "fv-plugins-message-container" }
const _hoisted_48 = { class: "fv-help-block" }
const _hoisted_49 = {
  key: 1,
  class: "row mb-3"
}
const _hoisted_50 = { class: "col-md-6 fv-row" }
const _hoisted_51 = { class: "fs-6 fw-bold form-label" }
const _hoisted_52 = { class: "fv-plugins-message-container" }
const _hoisted_53 = { class: "fv-help-block" }
const _hoisted_54 = { class: "col-md-6 fv-row" }
const _hoisted_55 = { class: "fs-6 fw-bold form-label mb-3" }
const _hoisted_56 = { class: "fv-plugins-message-container" }
const _hoisted_57 = { class: "fv-help-block" }
const _hoisted_58 = {
  key: 2,
  class: "row mb-3"
}
const _hoisted_59 = { class: "col-md-6 fv-row" }
const _hoisted_60 = { class: "required fs-6 fw-bold form-label mb-1" }
const _hoisted_61 = {
  key: 0,
  value: undefined
}
const _hoisted_62 = {
  key: 0,
  value: undefined
}
const _hoisted_63 = { class: "fv-plugins-message-container" }
const _hoisted_64 = { class: "fv-help-block" }
const _hoisted_65 = { class: "col-6 fv-row" }
const _hoisted_66 = { class: "required fs-6 fw-bold form-label mb-1" }
const _hoisted_67 = { class: "fv-plugins-message-container" }
const _hoisted_68 = { class: "fv-help-block" }
const _hoisted_69 = { class: "from-button" }
const _hoisted_70 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_71 = {
  key: 1,
  class: "spinner-border spinner-border-sm align-middle"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Field = _resolveComponent("Field")
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_RecursiveDropdown = _resolveComponent("RecursiveDropdown")
  const _component_Form = _resolveComponent("Form")

  return (_openBlock(), _createBlock(_component_Form, {
    id: "objective_form",
    onInput: _ctx.handleInput,
    ref: "formRef",
    class: "form row-cols-12 w-100 mt-n5",
    onSubmit: _ctx.submitForm,
    "validation-schema": _ctx.formValidate
  }, {
    default: _withId(() => [
      _withDirectives(_createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("label", _hoisted_3, _toDisplayString(_ctx.translate("objectiveType")), 1),
          _createVNode("div", _hoisted_4, [
            _createVNode("input", {
              type: "radio",
              class: ["btn-check", _ctx.form.subObjectives.length > 0 && 'disabled'],
              name: "objectiveType",
              id: "1",
              value: "objective",
              autocomplete: "off",
              disabled: _ctx.isCicloRunningOrFinished(_ctx.selectedPeriods)
            }, null, 10, ["disabled"]),
            _createVNode("label", {
              class: [
              'btn',
              'btn-outline-primary',
              'btn-custom',
              _ctx.form.type === 'objective' ? 'btn-activo' : ''
            ],
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => {
              _ctx.setType('objective');
              _ctx.handleInput();
            }, ["prevent"])),
              for: "1"
            }, _toDisplayString(_ctx.translate("typeObjective")), 3),
            _createVNode("input", {
              type: "radio",
              class: ["btn-check", {
              'disabled-style': _ctx.isCicloRunningOrFinished(_ctx.selectedPeriods)
            }],
              name: "objectiveType",
              id: "2",
              value: "key_result",
              autocomplete: "off",
              disabled: _ctx.isCicloRunningOrFinished(_ctx.selectedPeriods)
            }, null, 10, ["disabled"]),
            _createVNode("label", {
              class: [
              _ctx.form.type === 'key_result'
                ? 'btn btn-outline-primary btn-activo'
                : 'btn btn-outline-primary',
              'btn-custom',
              _ctx.form.subObjectives.length > 0 && 'disabled'
            ],
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => {
              _ctx.setType('key_result');
              _ctx.handleInput();
            }, ["prevent"])),
              for: "2"
            }, _toDisplayString(_ctx.translate("typeKeyResult")), 3)
          ]),
          _createVNode(_component_Field, {
            modelValue: _ctx.form.type,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.type = $event)),
            name: "objectiveType",
            class: ["form-select form-select-solid oculto", {
            'disabled-style': _ctx.isCicloRunningOrFinished(_ctx.selectedPeriods)
          }],
            "data-control": "select2",
            "data-hide-search": "true",
            "data-placeholder": "Type",
            as: "select",
            disabled: _ctx.isCicloRunningOrFinished(_ctx.selectedPeriods)
          }, {
            default: _withId(() => [
              _hoisted_5,
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.objectiveTypeList, (objType) => {
                return (_openBlock(), _createBlock("option", {
                  key: objType.id,
                  value: objType.code
                }, _toDisplayString(_ctx.translate(objType.name)), 9, ["value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "class", "disabled"]),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_ErrorMessage, { name: "objectiveType" })
            ])
          ])
        ])
      ], 512), [
        [_vShow, _ctx.form.add === true || _ctx.form.parent != null]
      ]),
      (_ctx.form.type)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode("label", _hoisted_10, [
                  _createVNode("span", _hoisted_11, _toDisplayString(_ctx.translate("objectiveTitle")), 1),
                  _hoisted_12
                ]),
                _createVNode(_component_Field, {
                  type: "text",
                  class: ["form-control form-control-solid", {
              'disabled-style': _ctx.isCicloRunningOrFinished(_ctx.selectedPeriods)
            }],
                  placeholder: "",
                  name: "title",
                  modelValue: _ctx.form.title,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.title = $event)),
                  disabled: _ctx.isCicloRunningOrFinished(_ctx.selectedPeriods)
                }, null, 8, ["modelValue", "class", "disabled"]),
                _createVNode("div", _hoisted_13, [
                  _createVNode("div", _hoisted_14, [
                    _createVNode(_component_ErrorMessage, { name: "title" })
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_15, [
              _createVNode("div", _hoisted_16, [
                _createVNode("label", _hoisted_17, [
                  _createVNode("span", null, _toDisplayString(_ctx.translate("description")), 1),
                  _hoisted_18
                ]),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.description,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.description = $event)),
                  type: "textarea",
                  rows: "3",
                  name: "description",
                  placeholder: _ctx.translate('objectiveDescriptions'),
                  id: "description",
                  class: {
              'custom-disabled': _ctx.isCicloRunningOrFinished(_ctx.selectedPeriods)
            },
                  disabled: _ctx.isCicloRunningOrFinished(_ctx.selectedPeriods)
                }, null, 8, ["modelValue", "placeholder", "class", "disabled"])
              ])
            ]),
            _createVNode("div", _hoisted_19, [
              _createVNode("div", _hoisted_20, [
                _createVNode("label", _hoisted_21, _toDisplayString(_ctx.translate("owner")), 1),
                _createVNode(_component_Field, {
                  modelValue: _ctx.form.user.id,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.user.id = $event)),
                  name: "user",
                  class: ["form-select form-select-solid", {
              'disabled-style': _ctx.isCicloRunningOrFinished(_ctx.selectedPeriods)
            }],
                  "data-control": "select2",
                  "data-hide-search": "true",
                  "data-placeholder": "User",
                  as: "select",
                  disabled: _ctx.isCicloRunningOrFinished(_ctx.selectedPeriods)
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.members, (member) => {
                      return (_openBlock(), _createBlock("option", {
                        key: member.id,
                        value: member.user
                      }, _toDisplayString(member.name) + " " + _toDisplayString(member.lastname), 9, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "class", "disabled"]),
                _createVNode("div", _hoisted_22, [
                  _createVNode("div", _hoisted_23, [
                    _createVNode(_component_ErrorMessage, { name: "user" })
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_24, [
              _createVNode("div", _hoisted_25, [
                _createVNode("label", {
                  class: 
              _ctx.form.type === 'key_result'
                ? 'required fs-6 fw-bold form-label mb-1'
                : 'fs-6 fw-bold form-label mb-1'
            
                }, _toDisplayString(_ctx.translate("unitOfMeasurement")), 3),
                _createVNode("div", _hoisted_26, [
                  _createVNode(_component_Field, {
                    type: "text",
                    modelValue: _ctx.form.unit,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.unit = $event)),
                    name: "unit",
                    class: ["form-control form-control-solid dropdown-toggle", {
                'disabled-style': _ctx.isCicloRunningOrFinished(_ctx.selectedPeriods)
              }],
                    placeholder: "",
                    "data-bs-toggle": "dropdown",
                    disabled: _ctx.isCicloRunningOrFinished(_ctx.selectedPeriods)
                  }, null, 8, ["modelValue", "class", "disabled"]),
                  _createVNode("button", _hoisted_27, _toDisplayString(_ctx.translate("suggestions")), 1),
                  _createVNode("ul", _hoisted_28, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.units, (unit) => {
                      return (_openBlock(), _createBlock("li", {
                        key: unit.id
                      }, [
                        _createVNode("button", {
                          class: "dropdown-item",
                          onClick: _withModifiers(($event: any) => (_ctx.suggestion(_ctx.translate(unit.name))), ["prevent"])
                        }, _toDisplayString(_ctx.translate(unit.name)), 9, ["onClick"])
                      ]))
                    }), 128))
                  ])
                ]),
                _createVNode("div", _hoisted_29, [
                  _createVNode("div", _hoisted_30, [
                    _createVNode(_component_ErrorMessage, { name: "unit" })
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_31, [
                _createVNode("label", _hoisted_32, [
                  _createVNode("span", null, _toDisplayString(_ctx.translate("code")), 1)
                ]),
                _createVNode(_component_Field, {
                  type: "text",
                  class: ["form-control form-control-solid", {
              'disabled-style': _ctx.isCicloRunningOrFinished(_ctx.selectedPeriods)
            }],
                  placeholder: "",
                  name: "code",
                  modelValue: _ctx.form.code,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.code = $event)),
                  disabled: _ctx.isCicloRunningOrFinished(_ctx.selectedPeriods)
                }, null, 8, ["modelValue", "disabled", "class"]),
                _createVNode("div", _hoisted_33, [
                  _createVNode("div", _hoisted_34, [
                    _createVNode(_component_ErrorMessage, { name: "code" })
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_35, [
              _createVNode("div", {
                class: {
            'col-6': _ctx.form.id == null,
            'col-4': _ctx.form.id != null
          }
              }, [
                _createVNode("label", {
                  class: 
              _ctx.form.type === 'key_result'
                ? 'required fs-6 fw-bold form-label mb-1'
                : 'fs-6 fw-bold form-label mb-1'
            
                }, _toDisplayString(_ctx.translate("startValue")), 3),
                _createVNode(_component_Field, {
                  type: "text",
                  class: ["form-control form-control-solid", {
              'disabled-style': _ctx.isCicloRunningOrFinished(_ctx.selectedPeriods)
            }],
                  placeholder: "",
                  name: "startValue",
                  "data-rules": "numeric:1",
                  modelValue: _ctx.form.startValue,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.startValue = $event)),
                  disabled: _ctx.isCicloRunningOrFinished(_ctx.selectedPeriods)
                }, null, 8, ["modelValue", "class", "disabled"]),
                _createVNode("div", _hoisted_36, [
                  _createVNode("div", _hoisted_37, [
                    _createVNode(_component_ErrorMessage, { name: "startValue" })
                  ])
                ])
              ], 2),
              _withDirectives(_createVNode("div", _hoisted_38, [
                _createVNode("label", _hoisted_39, _toDisplayString(_ctx.translate("valueNow")), 1),
                _createVNode(_component_Field, {
                  type: "text",
                  class: "form-control form-control-solid",
                  placeholder: "",
                  name: "currentValue",
                  "data-rules": "numeric:1",
                  modelValue: _ctx.form.currentValue,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.currentValue = $event))
                }, null, 8, ["modelValue"]),
                _createVNode("div", _hoisted_40, [
                  _createVNode("div", _hoisted_41, [
                    _createVNode(_component_ErrorMessage, { name: "currentValue" })
                  ])
                ])
              ], 512), [
                [_vShow, _ctx.form.id]
              ]),
              _createVNode("div", {
                class: {
            'col-6': _ctx.form.id == null,
            'col-4': _ctx.form.id != null
          }
              }, [
                _createVNode("label", {
                  class: 
              _ctx.form.type === 'key_result'
                ? 'required fs-6 fw-bold form-label mb-1'
                : 'fs-6 fw-bold form-label mb-1'
            
                }, _toDisplayString(_ctx.translate("objectiveValue")), 3),
                _createVNode(_component_Field, {
                  type: "text",
                  class: ["form-control form-control-solid", {
              'disabled-style': _ctx.isCicloRunningOrFinished(_ctx.selectedPeriods)
            }],
                  placeholder: "",
                  name: "targetValue",
                  "data-rules": "numeric:1",
                  modelValue: _ctx.form.targetValue,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.targetValue = $event)),
                  disabled: _ctx.isCicloRunningOrFinished(_ctx.selectedPeriods)
                }, null, 8, ["modelValue", "class", "disabled"]),
                _createVNode("div", _hoisted_42, [
                  _createVNode("div", _hoisted_43, [
                    _createVNode(_component_ErrorMessage, { name: "targetValue" })
                  ])
                ])
              ], 2)
            ]),
            (_ctx.form.type === 'key_result')
              ? (_openBlock(), _createBlock("div", _hoisted_44, [
                  _createVNode("div", _hoisted_45, [
                    _createVNode("label", _hoisted_46, _toDisplayString(_ctx.translate("frequency")), 1),
                    _createVNode(_component_Field, {
                      modelValue: _ctx.form.frequency,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.form.frequency = $event)),
                      name: "frequency",
                      class: ["form-select form-select-solid", {
              'disabled-style': _ctx.isCicloRunningOrFinished(_ctx.selectedPeriods)
            }],
                      "data-control": "select2",
                      "data-hide-search": "true",
                      "data-placeholder": "frequency",
                      as: "select",
                      disabled: _ctx.isCicloRunningOrFinished(_ctx.selectedPeriods)
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.frequencies, (frequency) => {
                          return (_openBlock(), _createBlock("option", {
                            key: frequency.id,
                            value: frequency.code
                          }, _toDisplayString(_ctx.translate(frequency.name)), 9, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "class", "disabled"]),
                    _createVNode("div", _hoisted_47, [
                      _createVNode("div", _hoisted_48, [
                        _createVNode(_component_ErrorMessage, { name: "frequency" })
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.form.frequency === 'single' && _ctx.form.type === 'key_result')
              ? (_openBlock(), _createBlock("div", _hoisted_49, [
                  _createVNode("div", _hoisted_50, [
                    _createVNode("label", _hoisted_51, _toDisplayString(_ctx.translate("differentiatedStart")), 1),
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.form.differentiatedStart,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.form.differentiatedStart = $event)),
                      style: {"border-radius":"0.475rem","border":"1px solid #e4e6ef","border-color":"rgb(217, 217, 217)"},
                      type: "date",
                      placeholder: _ctx.translate('differentiatedStart'),
                      class: {
              'disabled-style': _ctx.isCicloRunningOrFinished(_ctx.selectedPeriods)
            },
                      disabled: _ctx.isCicloRunningOrFinished(_ctx.selectedPeriods),
                      onChange: _ctx.handleInput
                    }, null, 8, ["modelValue", "placeholder", "class", "disabled", "onChange"]),
                    _createVNode("div", _hoisted_52, [
                      _createVNode("div", _hoisted_53, [
                        _createVNode(_component_ErrorMessage, { name: "differentiatedStart" })
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_54, [
                    _createVNode("label", _hoisted_55, _toDisplayString(_ctx.translate("earlyEnding")), 1),
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.form.earlyEnding,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.form.earlyEnding = $event)),
                      style: {"border-radius":"0.475rem","border":"1px solid #e4e6ef","border-color":"rgb(217, 217, 217)","bottom":"3px"},
                      type: "date",
                      placeholder: _ctx.translate('earlyEnding'),
                      class: {
              'disabled-style': _ctx.isCicloRunningOrFinished(_ctx.selectedPeriods)
            },
                      disabled: _ctx.isCicloRunningOrFinished(_ctx.selectedPeriods),
                      onChange: _ctx.handleInput
                    }, null, 8, ["modelValue", "placeholder", "class", "disabled", "onChange"]),
                    _createVNode("div", _hoisted_56, [
                      _createVNode("div", _hoisted_57, [
                        _createVNode(_component_ErrorMessage, { name: "earlyEnding" })
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.form.id)
              ? (_openBlock(), _createBlock("div", _hoisted_58, [
                  _createVNode("div", _hoisted_59, [
                    _createVNode("label", _hoisted_60, _toDisplayString(_ctx.translate("fathersGoal")), 1),
                    (!_ctx.form.add)
                      ? (_openBlock(), _createBlock(_component_Field, {
                          key: 0,
                          modelValue: _ctx.form.parent,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.form.parent = $event)),
                          name: "fathersGoal",
                          class: ["form-select form-select-solid", {
              'disabled-style': _ctx.isCicloRunningOrFinished(_ctx.selectedPeriods)
            }],
                          "data-control": "select2",
                          "data-hide-search": "true",
                          as: "select",
                          disabled: _ctx.isCicloRunningOrFinished(_ctx.selectedPeriods)
                        }, {
                          default: _withId(() => [
                            (_ctx.form.type !== 'key_result')
                              ? (_openBlock(), _createBlock("option", _hoisted_61, _toDisplayString(_ctx.translate("withoutParent")), 1))
                              : _createCommentVNode("", true),
                            (!_ctx.form.add)
                              ? (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.objectives, (objective) => {
                                  return (_openBlock(), _createBlock(_component_RecursiveDropdown, {
                                    key: objective.id,
                                    element: objective,
                                    selectedObjective: _ctx.form.id
                                  }, null, 8, ["element", "selectedObjective"]))
                                }), 128))
                              : (_openBlock(), _createBlock("option", {
                                  key: 2,
                                  value: _ctx.form.id
                                }, _toDisplayString(_ctx.form.addTitle), 9, ["value"]))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "class", "disabled"]))
                      : (_openBlock(), _createBlock(_component_Field, {
                          key: 1,
                          modelValue: _ctx.form.id,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.form.id = $event)),
                          name: "fathersGoal",
                          class: ["form-select form-select-solid", {
              'disabled-style': _ctx.isCicloRunningOrFinished(_ctx.selectedPeriods)
            }],
                          "data-control": "select2",
                          "data-hide-search": "true",
                          as: "select",
                          disabled: _ctx.isCicloRunningOrFinished(_ctx.selectedPeriods)
                        }, {
                          default: _withId(() => [
                            (_ctx.form.type !== 'key_result')
                              ? (_openBlock(), _createBlock("option", _hoisted_62, _toDisplayString(_ctx.translate("withoutParent")), 1))
                              : _createCommentVNode("", true),
                            (!_ctx.form.add)
                              ? (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.objectives, (objective) => {
                                  return (_openBlock(), _createBlock(_component_RecursiveDropdown, {
                                    key: objective.id,
                                    element: objective,
                                    selectedObjective: _ctx.form.id
                                  }, null, 8, ["element", "selectedObjective"]))
                                }), 128))
                              : (_openBlock(), _createBlock("option", {
                                  key: 2,
                                  value: _ctx.form.id
                                }, _toDisplayString(_ctx.form.addTitle), 9, ["value"]))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "class", "disabled"])),
                    _createVNode("div", _hoisted_63, [
                      _createVNode("div", _hoisted_64, [
                        _createVNode(_component_ErrorMessage, { name: "fathersGoal" })
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_65, [
                    _createVNode("label", _hoisted_66, _toDisplayString(_ctx.translate("cycle")), 1),
                    _createVNode(_component_Field, {
                      modelValue: _ctx.form.period,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.form.period = $event)),
                      name: "period",
                      class: ["form-select form-select-solid", {
              'disabled-style': _ctx.isCicloRunningOrFinished(_ctx.selectedPeriods)
            }],
                      "data-control": "select2",
                      "data-hide-search": "true",
                      "data-placeholder": "Period",
                      as: "select",
                      disabled: _ctx.isCicloRunningOrFinished(_ctx.selectedPeriods)
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.periods, (period) => {
                          return (_openBlock(), _createBlock("option", {
                            key: period.id,
                            value: period.id
                          }, _toDisplayString(period.name), 9, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "class", "disabled"]),
                    _createVNode("div", _hoisted_67, [
                      _createVNode("div", _hoisted_68, [
                        _createVNode(_component_ErrorMessage, { name: "period" })
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_69, [
        _createVNode("button", {
          disabled: _ctx.loadingObjective || !_ctx.formChanged,
          type: "submit",
          class: ["btn btn-primary floating-button center", { 'btn-disabled': !_ctx.formChanged }],
          style: {"min-width":"102px"}
        }, [
          (!_ctx.loadingObjective)
            ? (_openBlock(), _createBlock("span", _hoisted_70, _toDisplayString(_ctx.translate("save")), 1))
            : (_openBlock(), _createBlock("span", _hoisted_71))
        ], 10, ["disabled"])
      ])
    ]),
    _: 1
  }, 8, ["onInput", "onSubmit", "validation-schema"]))
})